export default __webpack_public_path__ + "static/media/romango-screenshot-01.740a9161.png";